<template lang='pug'>
  .fpui-containers
    .row
      .col-md-4(:key='idx', v-for='consumer, idx in consumers')
        .well
          h3.title {{ consumer }}
          .types-container.row
            .col-md-6(:key='idx', v-for='type, idx in types(consumer)')
              .type(@click='go(consumer, type)')
                .type-container
                  h4.title-type {{ type }}
</template>

<script>

export default {
  computed: {
    consumers () { return this.$store.getters.PACKAGES_CONSUMERS },
    types () { return this.$store.getters.PACKAGES_TYPES_BY_CONSUMER }
  },
  methods: {
    go (consumer, type) { this.$router.push(`/packages/${consumer}/${type}`) }
  }
}
</script>

<style lang='less'>
  @import "~@/shared/styles/_variables.less";

  .fpui-containers {
    text-align: center;
    .col-md-4 {
      padding: 5px;
      .title {
        margin: 0;
        padding: 10px 5px;
        text-transform: capitalize !important;
      }
      .types-container {
        .col-md-6 {
          padding: 5px;
        }
        .type {
          height: 100px;
          widtH: 100%;
          position: relative;
          padding: 5px;
          border: 1px solid @grey;
          cursor: pointer;
          .type-container {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .title-type {
            margin: 0;
            text-transform: capitalize !important;
          }
          &:hover {
            background-color: @blue;
            color: @white;
            .title-type {
              color: @white;
            }
          }
        }
      }
    }
  }
</style>
